var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVinylRecord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7571 11.2331H4.14377C3.96995 11.2331 3.82457 11.1022 3.80606 10.9293L2.76852 1.19596C2.7473 0.995041 2.90442 0.820312 3.10624 0.820312H16.7942C16.996 0.820312 17.1536 0.995492 17.1319 1.19596L16.0944 10.9293C16.0759 11.1022 15.93 11.2331 15.7566 11.2331H15.7571Z",
    fill: "#FFF057",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0678 6.46024C12.0371 7.36007 11.0895 8.07072 9.95079 8.07072C8.81212 8.07072 7.86444 7.36007 7.83373 6.46024C7.80303 5.56041 8.74982 4.76172 9.95079 4.76172C11.1522 4.76172 12.0994 5.53332 12.0678 6.46024Z",
    fill: "#FFF057",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1181 6.45951C10.1181 6.53175 10.0427 6.59044 9.95018 6.59044C9.85763 6.59044 9.78268 6.53175 9.78223 6.45951C9.78178 6.38727 9.85718 6.32812 9.95018 6.32812C10.0432 6.32812 10.1181 6.38682 10.1181 6.45951Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6715 14.9224H3.23051C3.02959 14.9224 2.86073 14.7707 2.83951 14.5707L1.63899 3.30588C1.61416 3.07336 1.79611 2.87109 2.02998 2.87109H17.872C18.1054 2.87109 18.2878 3.07381 18.263 3.30588L17.0625 14.5711C17.0413 14.7711 16.8724 14.9228 16.6715 14.9228V14.9224Z",
    fill: "#FFF057",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4004 9.39549C12.3648 10.4371 11.2685 11.2593 9.95017 11.2593C8.63181 11.2593 7.53558 10.4366 7.49991 9.39549C7.46334 8.32274 8.56002 7.42969 9.95017 7.42969C11.3403 7.42969 12.437 8.32274 12.4004 9.39549Z",
    fill: "#FFF057",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1451 9.39825C10.1451 9.48177 10.058 9.5495 9.95098 9.5495C9.84397 9.5495 9.75684 9.48177 9.75684 9.39825C9.75684 9.31472 9.84352 9.24609 9.95098 9.24609C10.0584 9.24609 10.1456 9.31427 10.1451 9.39825Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3398 18.2314H2.56105C2.33981 18.2314 2.1547 18.0648 2.13122 17.8449L0.811055 5.4586C0.783965 5.20306 0.983977 4.98047 1.24088 4.98047H18.6595C18.9164 4.98047 19.1164 5.20306 19.0893 5.4586L17.7692 17.8449C17.7457 18.0648 17.5601 18.2314 17.3393 18.2314H17.3398Z",
    fill: "#FFF057",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4698 12.1594C17.1736 15.2748 13.8163 17.6252 9.95064 17.6252C6.08495 17.6252 2.72809 15.2743 2.43146 12.1594C2.10999 8.77776 5.46459 5.81641 9.95064 5.81641C14.4367 5.81641 17.7913 8.77776 17.4698 12.1594Z",
    fill: "#FFF057",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.644 12.1613C12.6052 13.3063 11.3992 14.2106 9.94992 14.2106C8.50063 14.2106 7.29469 13.3063 7.25586 12.1613C7.21568 10.982 8.42116 10 9.94992 10C11.4787 10 12.6842 10.982 12.644 12.1613Z",
    fill: "#FFF057",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1634 12.1592C10.1634 12.2513 10.0677 12.3258 9.94989 12.3258C9.83205 12.3258 9.73678 12.2513 9.73633 12.1592C9.73588 12.0671 9.83159 11.9922 9.94989 11.9922C10.0682 11.9922 10.1639 12.0671 10.1634 12.1592Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3398 18.2314H2.56105C2.33981 18.2314 2.1547 18.0648 2.13122 17.8449L0.811055 5.4586C0.783965 5.20306 0.983977 4.98047 1.24088 4.98047H18.6595C18.9164 4.98047 19.1164 5.20306 19.0893 5.4586L17.7692 17.8449C17.7457 18.0648 17.5601 18.2314 17.3393 18.2314H17.3398Z",
    fill: "#FFF057",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2264 12.0286C15.0186 14.2144 12.663 15.8635 9.95076 15.8635C7.23849 15.8635 4.88323 14.214 4.6751 12.0286C4.44955 9.65589 6.80323 7.57812 9.95076 7.57812C13.0983 7.57812 15.452 9.65589 15.2264 12.0286Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0681 11.8934C12.0376 12.793 11.0901 13.5036 9.95144 13.5036C8.81275 13.5036 7.86526 12.793 7.83475 11.8934C7.80318 10.9669 8.75032 10.1953 9.95144 10.1953C11.1526 10.1953 12.0997 10.9669 12.0681 11.8934Z",
    fill: "#FFF057"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1634 11.9014C10.1634 11.9935 10.0677 12.068 9.94989 12.068C9.83205 12.068 9.73678 11.9935 9.73633 11.9014C9.73588 11.8093 9.83159 11.7344 9.94989 11.7344C10.0682 11.7344 10.1639 11.8093 10.1634 11.9014Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinylRecord);
export default __webpack_public_path__ + "static/media/vinyl-record.5a1639d7f24693af71d733eef88ac805.svg";
export { ForwardRef as ReactComponent };